import { useState, useEffect } from 'react';

export default function useAutoSubmit(formik) {
    const [touched, setTouched] = useState({});
    const [success, setSuccess] = useState({});

    const getFieldExtraProps = (name) => {
        const fieldMeta = formik.getFieldMeta(name);

        function handleBlur(e) {
            setTouched((prev) => ({ ...prev, [name]: true }));
            formik.handleBlur(e);
        }

        return {
            onBlur: handleBlur,
            error: fieldMeta.error,
        };
    };

    useEffect(() => {
        if (formik.dirty && Object.keys(touched).length) formik.submitForm();
    }, [touched]);

    useEffect(() => {
        if (formik.status === 'success') {
            setTouched({});
            const newSuccess = { ...touched };
            setSuccess((prev) => ({ ...prev, ...newSuccess }));

            setTimeout(() => {
                setSuccess((prev) => {
                    const newState = { ...prev };
                    for (let prop in newSuccess) {
                        newState[prop] = false;
                    }
                    return newState;
                });
            }, 3000);

            formik.resetForm({ values: formik.values });
        }
    }, [formik.status]);

    return { getFieldExtraProps, success };
}
